export const translations = {
  en: {
    // Header & Navigation
    nav: {
      solutions: 'Solutions',
      solutionsMenu: 'Solutions',
      products: 'Products',
      company: 'Company',
      blog: 'Blog',
      balticHub: 'Hub 2026',
      balticHubBadge: 'NEW',
      infrastructure: 'Infrastructure',
      devices: 'Devices',
      partners: 'Partners',
      consulting: 'Consulting',
      industries: 'Industries',
      about: 'About',
      contact: 'Contact',
      scheduleDemo: 'Schedule a Demo',
      // Solutions dropdown items
      smartMetering: 'Smart Metering',
      assetTracking: 'Asset Tracking',
      toolTracking: 'Tool Tracking',
      indoorAirQuality: 'Indoor Air Quality',
      smartLockers: 'Smart Lockers',
      buildingEnergy: 'Building Energy',
      officeSpace: 'Office Space',
      smartCities: 'Smart Cities',
      realEstate: 'Real Estate & Infrastructure',
      iotSolutions: 'IoT Solutions',
      // Products dropdown items
      tektelic: 'TEKTELIC',
      tektelicDesc: 'LoRaWAN Infrastructure',
      connectivity: 'Connectivity',
      connectivityDesc: 'Network Solutions',
      hardwareInfra: 'Hardware & Infrastructure',
    },
    // Blog Page
    blog: {
      badge: 'Blog & Insights',
      title: 'IoT Knowledge Hub',
      subtitle: 'Explore articles, guides, and case studies on LoRaWAN infrastructure, smart cities, indoor air quality monitoring, and industrial IoT solutions.',
      all: 'All',
      smartCities: 'Smart Cities',
      indoorAirQuality: 'Indoor Air Quality',
      smartMetering: 'Smart Metering',
      assetTracking: 'Asset Tracking',
      energyEfficiency: 'Energy Efficiency',
      productReviews: 'Product Reviews',
      readMore: 'Read more',
      loadMore: 'Load More Articles',
      minRead: 'min read',
      newsletterBadge: 'Stay Updated',
      newsletterTitle: 'Subscribe to Our Newsletter',
      newsletterSubtitle: 'Get the latest IoT insights, case studies, and product updates delivered to your inbox monthly.',
      newsletterPlaceholder: 'Enter your email',
      newsletterButton: 'Subscribe',
      newsletterDisclaimer: 'No spam. Unsubscribe anytime.',
      // Sample articles
      article1Title: 'Building Scalable LoRaWAN Infrastructure for Smart Cities',
      article1Excerpt: 'How cities across the Baltics are deploying LoRaWAN networks to enable smart metering, environmental monitoring, and connected infrastructure at scale.',
      article2Title: 'Indoor Air Quality Monitoring in Schools: A Complete Guide',
      article2Excerpt: 'Why CO2 monitoring matters for student health and performance, and how to implement effective IAQ monitoring systems in educational facilities.',
      article3Title: 'Smart Metering for Utilities: ROI and Implementation Best Practices',
      article3Excerpt: 'A comprehensive look at how utilities are using IoT-based smart meters to improve efficiency, reduce losses, and enhance customer service.',
      article4Title: 'Real-Time Asset Tracking in Logistics: LoRaWAN vs GPS',
      article4Excerpt: 'Comparing connectivity options for asset tracking in logistics operations. When to use LoRaWAN, GPS, Sigfox, or hybrid solutions.',
      article5Title: 'How IoT Sensors Reduce Building Energy Consumption by 30%',
      article5Excerpt: 'Case studies and technical approaches for using connected sensors and smart controls to optimize HVAC and lighting in commercial buildings.',
      article6Title: 'TEKTELIC BREEZE: In-Depth Review of the CO2 Smart Room Sensor',
      article6Excerpt: 'A detailed look at the TEKTELIC BREEZE sensor family, including specifications, deployment scenarios, and integration options.',
    },
    // Hero Section
    hero: {
      badge: 'IoT Solutions Provider',
      title: 'IoT Infrastructure and Smart Solutions for the',
      titleHighlight: 'Baltics',
      subtitle: 'We help cities, utilities and companies deploy IoT infrastructure that reduces operational costs.',
      ctaPrimary: 'Schedule a Demo',
      ctaSecondary: 'Explore solutions',
      trustedTech: 'Trusted technologies',
      yearsExp: 'Years of IoT Experience',
      deployedDevices: 'Deployed IoT Devices',
      balticCountries: 'Baltic Countries',
    },
    // Solutions Section
    solutions: {
      label: 'Solutions',
      title: 'IoT Solutions',
      subtitle: 'Comprehensive IoT solutions designed to reduce operational costs and improve efficiency across industries.',
      smartLockers: 'Smart Lockers',
      smartLockersDesc: 'Automated locker infrastructure for logistics, offices and public services.',
      smartMetering: 'Smart Metering',
      smartMeteringDesc: 'Carrier-grade gateways and remote data collection for utilities.',
      assetTracking: 'Asset Tracking',
      assetTrackingDesc: 'Indoor and outdoor tracking using LoRaWAN, Sigfox, NB-IoT, BLE and satellite connectivity.',
      elderlyCare: 'Elderly Care Solutions',
      elderlyCareDesc: 'Connected sensors and monitoring technologies for assisted living.',
      airQuality: 'Indoor Air Quality Monitoring',
      airQualityDesc: 'CO2 and environmental monitoring for buildings and workplaces.',
      smartOffice: 'Smart cities & critical infrastructures',
      smartOfficeDesc: 'Occupancy analytics and workspace optimization.',
      learnMore: 'Learn more',
    },
    // Specialized Solutions
    specialized: {
      label: 'Our Products',
      title: 'Specialized IoT Solutions',
      subtitle: 'Real-world IoT deployments developed and operated by 0g Baltics.',
      klinikTrack: 'Klinik Track',
      klinikTrackSub: 'Hospital Asset Tracking',
      klinikTrackDesc: 'Track medical equipment and improve hospital logistics.',
      stickGo: 'Stick & Go',
      stickGoSub: 'Connected Sticker Tracker',
      stickGoDesc: 'Ultra-light IoT tracking for assets and logistics.',
      eldera: 'Eldera',
      elderaSub: 'Connected Elderly Care',
      elderaDesc: 'Sensors and monitoring solutions for assisted living and senior safety.',
      smartParking: 'Smart Parking',
      smartParkingSub: 'Parking Infrastructure',
      smartParkingDesc: 'Smart parking infrastructure and occupancy monitoring.',
      pakuskapis: 'Pakuskapis',
      pakuskapisSub: 'Automated Parcel Lockers',
      pakuskapisDesc: 'Automated parcel locker infrastructure for cities and logistics operators.',
      bibliomats: 'Knygomatai / Bibliomats',
      bibliomatsSub: 'Smart Library Lockers',
      bibliomatsDesc: 'Smart library locker systems for automated book pickup and returns.',
      smartEnergy: 'Smart Energy Monitoring',
      smartEnergySub: 'Energy Optimization',
      smartEnergyDesc: 'Remote energy monitoring and optimisation for buildings and infrastructure.',
      medicalDevices: 'Medical Devices',
      medicalDevicesSub: 'E-Health Solutions',
      medicalDevicesDesc: 'Connected medical devices and e-health infrastructure for healthcare providers.',
      toolTracking: 'Tool Tracking',
      toolTrackingSub: 'Industrial Tool Management',
      toolTrackingDesc: 'Smart lockers, RFID tracking and automated distribution systems for industrial tools.',
      realEstate: 'Real Estate & Infrastructure',
      realEstateSub: 'Smart Buildings Suite',
      realEstateDesc: 'Turnkey IoT for real estate developers, owners and asset managers — energy, leak detection, IAQ, occupancy and more.',
      e2Insurance: 'E2 Insurance',
      e2InsuranceSub: 'Water Leak Prevention for Insurers',
      e2InsuranceDesc: 'Connected risk prevention for insurance companies — detect water leaks earlier, react faster and reduce claim severity.',
      newBadge: 'New',
      visitWebsite: 'Visit website',
    },
    testimonials: {
      label: 'Testimonials',
      title: 'What our clients say',
      subtitle: 'Feedback from organisations using our IoT solutions across the Baltics.',
      q1: '0g Baltics helped us move from manual readings to full remote monitoring. Deployment was fast and the data has been reliable from day one.',
      r1: 'Operations Manager, utility company — Latvia',
      q2: 'We finally see how our buildings actually perform. Energy and air-quality data helped us reduce waste without expensive refurbishment.',
      r2: 'Facility Director, commercial real estate — Lithuania',
      q3: 'A pragmatic partner: they proposed the right technology for each use case instead of pushing a single product.',
      r3: 'Innovation Lead, municipality — Estonia',
    },
    // Tektelic Section
    tektelic: {
      label: 'LoRaWAN Infrastructure',
      title: 'Carrier-Grade LoRaWAN Infrastructure with',
      titleHighlight: 'Tektelic',
      description: '0g Baltics deploys LoRaWAN networks using Tektelic carrier-grade gateways and devices. Our infrastructure is designed for reliability, industrial deployments, and large-scale city networks.',
      feature1: 'Carrier-grade reliability',
      feature2: 'Industrial deployments',
      feature3: 'City-wide networks',
      feature4: 'Large-scale infrastructure',
      cta: 'Explore LoRaWAN Infrastructure',
      partnerBadge: 'Authorized Partner',
    },
    // Viziosense Section
    viziosense: {
      label: 'Occupancy Intelligence',
      title: 'Occupancy Intelligence with',
      titleHighlight: 'Viziosense',
      description: 'Viziosense edge AI sensors combine cutting-edge computer vision with robust hardware design, delivering accurate, cost-effective, and privacy-first solutions that generate fast, measurable impact.',
      techSpecs: 'Technical Specifications',
      sensitivity: 'Sensitivity',
      sensitivityDesc: 'Crisp, reliable vision in ultra-low light',
      temperature: '0–95% RH',
      temperatureDesc: 'Built to withstand extreme outdoor conditions',
      wideAngle: 'Wide-Angle Vision',
      wideAngleDesc: 'Maximum coverage, minimum blind spots',
      productRange: 'Product Range',
      vizioPark: 'VizioPark',
      vizioParkDesc: 'Parking Occupancy Monitoring',
      vizioYard: 'VizioYard',
      vizioYardDesc: 'Outdoor yard and logistics monitoring',
      vizioCount: 'VizioCount',
      vizioCountDesc: 'Red light traffic vehicles counting',
      vizioCrowd: 'VizioCrowd',
      vizioCrowdDesc: 'Crosswalk pedestrian counting',
    },
    // Connectivity Section
    connectivity: {
      label: 'Connectivity',
      title: 'Multi-Network IoT Connectivity',
      subtitle: 'We select the most efficient network depending on your use case. Our expertise spans multiple connectivity technologies.',
      lorawan: 'LoRaWAN',
      lorawanDesc: 'Long-range, low-power wide area network for IoT',
      lorawanF1: 'Up to 15km range',
      lorawanF2: 'Low power consumption',
      lorawanF3: 'Bi-directional',
      sigfox: 'Sigfox',
      sigfoxDesc: 'Ultra-narrow band technology for simple IoT messages',
      sigfoxF1: 'Global coverage',
      sigfoxF2: 'Low cost',
      sigfoxF3: 'Simple integration',
      nbiot: 'NB-IoT',
      nbiotDesc: 'Narrowband cellular technology for IoT devices',
      nbiotF1: 'Deep indoor coverage',
      nbiotF2: 'Carrier-grade',
      nbiotF3: 'Secure',
      ble: 'BLE',
      bleDesc: 'Bluetooth Low Energy for short-range connectivity',
      bleF1: 'Indoor positioning',
      bleF2: 'Asset tracking',
      bleF3: 'Low energy',
      satellite: 'Satellite',
      satelliteDesc: 'Global connectivity including Starlink compatible',
      satelliteF1: 'Remote areas',
      satelliteF2: 'Backup connectivity',
      satelliteF3: 'Global reach',
    },
    // Devices Section
    devices: {
      label: 'Device Ecosystem',
      title: 'Best-in-Class IoT Devices',
      subtitle: 'We partner with leading IoT device manufacturers to provide reliable, industrial-grade solutions.',
      alsoPartnering: 'Also partnering with',
      andMore: 'and more.',
      technologyPartners: 'Technology Partners',
      deviceTypes: 'Device Types',
      networkTechnologies: 'Network Technologies',
      balticCountries: 'Baltic Countries',
    },
    // Customers Section
    customers: {
      label: 'Trusted By',
      title: 'Our Customers',
    },
    // Deployments Section
    deployments: {
      label: 'Deployments',
      title: 'They Use 0g Baltics Connectivity',
      subtitle: 'Our IoT infrastructure powers operations across diverse industries, delivering reliability and measurable results.',
      cities: 'Cities & Municipalities',
      citiesDesc: 'Smart city infrastructure for urban management and public services',
      utilities: 'Utilities',
      utilitiesDesc: 'Remote metering and monitoring for water, gas, and electricity',
      buildings: 'Commercial Buildings',
      buildingsDesc: 'Occupancy monitoring, air quality, and energy optimization',
      logistics: 'Logistics Networks',
      logisticsDesc: 'Asset tracking and fleet management across supply chains',
      healthcare: 'Healthcare Facilities',
      healthcareDesc: 'Patient monitoring and equipment tracking in care environments',
      trustStatement: 'Infrastructure you can rely on.',
      trustStatementSub: 'Built for industrial operations across the Baltics.',
    },
    // Platforms Section
    platforms: {
      label: 'Platform Flexibility',
      title: 'Open IoT Platforms',
      subtitle: '0g Baltics supports its own platforms, partner platforms, and third-party integrations. We ensure you\'re never locked into a single vendor ecosystem.',
      noLockIn: 'No vendor lock-in',
      ownPlatform: '0g Baltics Platform',
      ownPlatformDesc: 'Our proprietary backend and frontend platforms for complete IoT management',
      partnerPlatforms: 'Partner Platforms',
      partnerPlatformsDesc: 'Seamless integration with partner ecosystems and existing infrastructure',
      thirdParty: 'Third-Party Integration',
      thirdPartyDesc: 'Open APIs and standard protocols for any platform integration',
    },
    // Consulting Section
    consulting: {
      label: 'Consulting',
      title: 'Reduce Operational Costs with',
      titleHighlight: 'IoT',
      subtitle: 'Our consulting services help you design, plan, and deploy IoT infrastructure that delivers measurable cost reductions and operational improvements.',
      service1: 'Infrastructure design',
      service2: 'Device selection',
      service3: 'ROI modelling',
      service4: 'Pilot projects',
      service5: 'Deployment strategy',
      roiFocus: 'We focus on projects with',
      months: 'months',
      roiTarget: 'ROI payback time',
      cta: 'Schedule a Consultation',
    },
    // Infrastructure Section
    infrastructure: {
      label: 'Regional Expertise',
      title: 'Building IoT Infrastructure Across the Baltics',
      subtitle: '0g Baltics works with cities, utilities, industrial companies, and integrators to deploy scalable IoT infrastructure across Lithuania, Latvia, and Estonia.',
      cities: 'Cities & Municipalities',
      utilities: 'Utilities & Industry',
      integrators: 'Integrators & Partners',
    },
    // CTA Section
    cta: {
      title: 'Start Your IoT Project',
      subtitle: 'Ready to reduce operational costs and improve efficiency? Schedule a demo to see how IoT infrastructure can transform your operations.',
      button: 'Schedule a Demo',
    },
    // Contact Form
    contact: {
      label: 'Contact Us',
      title: 'Let\'s Discuss Your IoT Project',
      subtitle: 'Whether you\'re looking to deploy smart infrastructure, reduce operational costs, or explore IoT solutions, we\'re here to help.',
      email: 'Email',
      whatToExpect: 'What to expect',
      expect1: 'Response within 24 business hours',
      expect2: 'Initial consultation to understand your needs',
      expect3: 'Tailored solution proposal',
      fullName: 'Full Name',
      company: 'Company',
      phone: 'Phone',
      country: 'Country',
      selectCountry: 'Select country',
      interest: 'Interest',
      selectInterest: 'What are you interested in?',
      message: 'Message',
      messagePlaceholder: 'Tell us about your project...',
      checkCity: 'I represent a city or municipality',
      checkIntegrator: 'I am an integrator / installer',
      checkNewsletter: 'I agree to receive newsletters and updates',
      checkAgree: 'I agree to be contacted',
      submit: 'Send Message',
      sending: 'Sending...',
      thankYouTitle: 'Thank you for contacting 0g Baltics',
      thankYouMessage: 'Our team will review your request and get back to you shortly.',
      errorAgree: 'Please agree to be contacted',
      errorRequired: 'Please fill in all required fields',
      errorSubmit: 'Failed to submit form. Please try again.',
    },
    // Footer
    footer: {
      description: 'IoT Infrastructure and Smart Solutions for the Baltics. Reducing operational costs through connected devices and smart infrastructure.',
      navigation: 'Navigation',
      legal: 'Legal',
      privacyPolicy: 'Privacy Policy',
      gdpr: 'GDPR',
      terms: 'Terms of Service',
      imprint: 'Imprint / Legal Notice',
      offices: 'Our Offices',
      copyright: '© 2026 0g Baltics. All rights reserved.',
    },
    // Languages
    languages: {
      en: 'English',
      lv: 'Latvian',
      lt: 'Lithuanian',
      ee: 'Estonian',
      comingSoon: '(Coming soon)',
    },
    // Interest options
    interests: {
      smartLockers: 'Smart Lockers',
      smartMetering: 'Smart Metering',
      assetTracking: 'Asset Tracking',
      elderlyCare: 'Elderly Care Solutions',
      airQuality: 'Indoor Air Quality Monitoring',
      energyMonitoring: 'Energy Monitoring',
      officeManagement: 'Office Space Management',
      connectivity: 'Connectivity Infrastructure',
      tektelic: 'Tektelic Gateways',
      consulting: 'Cost Reduction Consulting',
    },
    // Countries
    countries: {
      lithuania: 'Lithuania',
      latvia: 'Latvia',
      estonia: 'Estonia',
      poland: 'Poland',
      finland: 'Finland',
      sweden: 'Sweden',
      germany: 'Germany',
      other: 'Other',
    },
  },
  
  lv: {
    // Header & Navigation
    nav: {
      solutions: 'Risinājumi',
      solutionsMenu: 'Risinājumi',
      products: 'Produkti',
      company: 'Uzņēmums',
      blog: 'Blogs',
      balticHub: 'Hub 2026',
      balticHubBadge: 'JAUNS',
      infrastructure: 'Infrastruktūra',
      devices: 'Ierīces',
      partners: 'Partneri',
      consulting: 'Konsultācijas',
      industries: 'Nozares',
      about: 'Par mums',
      contact: 'Kontakti',
      scheduleDemo: 'Pieteikt demonstrāciju',
      // Solutions dropdown items
      smartMetering: 'Viedā mērīšana',
      assetTracking: 'Aktīvu izsekošana',
      toolTracking: 'Instrumentu izsekošana',
      indoorAirQuality: 'Iekštelpu gaisa kvalitāte',
      smartLockers: 'Viedie skapīši',
      buildingEnergy: 'Ēku energoefektivitāte',
      officeSpace: 'Biroja telpas',
      smartCities: 'Viedās pilsētas',
      realEstate: 'Nekustamais īpašums un infrastruktūra',
      iotSolutions: 'IoT risinājumi',
      // Products dropdown items
      tektelic: 'TEKTELIC',
      tektelicDesc: 'LoRaWAN infrastruktūra',
      connectivity: 'Savienojamība',
      connectivityDesc: 'Tīkla risinājumi',
      hardwareInfra: 'Aparatūra un infrastruktūra',
    },
    // Blog Page
    blog: {
      badge: 'Blogs un ieskati',
      title: 'IoT zināšanu centrs',
      subtitle: 'Izpētiet rakstus, ceļvežus un gadījumu izpētes par LoRaWAN infrastruktūru, viedajām pilsētām, iekštelpu gaisa kvalitātes monitoringu un rūpnieciskajiem IoT risinājumiem.',
      all: 'Visi',
      smartCities: 'Viedās pilsētas',
      indoorAirQuality: 'Iekštelpu gaisa kvalitāte',
      smartMetering: 'Viedā mērīšana',
      assetTracking: 'Aktīvu izsekošana',
      energyEfficiency: 'Energoefektivitāte',
      productReviews: 'Produktu apskati',
      readMore: 'Lasīt vairāk',
      loadMore: 'Ielādēt vairāk rakstu',
      minRead: 'min lasīšana',
      newsletterBadge: 'Esiet informēti',
      newsletterTitle: 'Abonējiet mūsu jaunumus',
      newsletterSubtitle: 'Saņemiet jaunākos IoT ieskatus, gadījumu izpētes un produktu jaunumus katru mēnesi.',
      newsletterPlaceholder: 'Ievadiet savu e-pastu',
      newsletterButton: 'Abonēt',
      newsletterDisclaimer: 'Nav mēstuļu. Jebkurā laikā varat atteikties.',
      // Sample articles
      article1Title: 'Mērogojamas LoRaWAN infrastruktūras veidošana viedajām pilsētām',
      article1Excerpt: 'Kā pilsētas visā Baltijā izvieto LoRaWAN tīklus, lai nodrošinātu viedo mērīšanu, vides monitoringu un savienoto infrastruktūru.',
      article2Title: 'Iekštelpu gaisa kvalitātes monitorings skolās: pilnīgs ceļvedis',
      article2Excerpt: 'Kāpēc CO2 monitorings ir svarīgs skolēnu veselībai un sniegumam, un kā ieviest efektīvas IAQ uzraudzības sistēmas izglītības iestādēs.',
      article3Title: 'Viedā mērīšana komunālajiem uzņēmumiem: ROI un ieviešanas labākā prakse',
      article3Excerpt: 'Visaptverošs skatījums uz to, kā komunālie uzņēmumi izmanto IoT bāzētus viedos skaitītājus, lai uzlabotu efektivitāti.',
      article4Title: 'Reāllaika aktīvu izsekošana loģistikā: LoRaWAN vs GPS',
      article4Excerpt: 'Savienojamības iespēju salīdzinājums aktīvu izsekošanai loģistikas operācijās.',
      article5Title: 'Kā IoT sensori samazina ēku enerģijas patēriņu par 30%',
      article5Excerpt: 'Gadījumu izpētes un tehniskie risinājumi savienoto sensoru un viedo vadības ierīču izmantošanai HVAC optimizācijai.',
      article6Title: 'TEKTELIC BREEZE: CO2 viedās telpas sensora padziļināts apskats',
      article6Excerpt: 'Detalizēts skatījums uz TEKTELIC BREEZE sensoru saimi, ieskaitot specifikācijas un izvietošanas scenārijus.',
    },
    // Hero Section
    hero: {
      badge: 'IoT risinājumu sniedzējs',
      title: 'IoT infrastruktūra un viedie risinājumi',
      titleHighlight: 'Baltijā',
      subtitle: 'Mēs palīdzam pilsētām, komunālajiem uzņēmumiem un kompānijām ieviest IoT infrastruktūru, kas samazina darbības izmaksas.',
      ctaPrimary: 'Pieteikt demonstrāciju',
      ctaSecondary: 'Izpētīt risinājumus',
      trustedTech: 'Uzticamas tehnoloģijas',
      yearsExp: 'Gadu IoT pieredze',
      deployedDevices: 'Izvietotās IoT ierīces',
      balticCountries: 'Baltijas valstis',
    },
    // Solutions Section
    solutions: {
      label: 'Risinājumi',
      title: 'IoT risinājumi',
      subtitle: 'Visaptveroši IoT risinājumi, kas izstrādāti, lai samazinātu darbības izmaksas un uzlabotu efektivitāti dažādās nozarēs.',
      smartLockers: 'Viedie skapīši',
      smartLockersDesc: 'Automatizēta skapīšu infrastruktūra loģistikai, birojiem un sabiedriskajiem pakalpojumiem.',
      smartMetering: 'Viedā mērīšana',
      smartMeteringDesc: 'Operatoru klases vārtejas un attālināta datu vākšana komunālajiem pakalpojumiem.',
      assetTracking: 'Aktīvu izsekošana',
      assetTrackingDesc: 'Iekštelpu un āra izsekošana, izmantojot LoRaWAN, Sigfox, NB-IoT, BLE un satelītu savienojumu.',
      elderlyCare: 'Senioru aprūpes risinājumi',
      elderlyCareDesc: 'Savienotie sensori un uzraudzības tehnoloģijas aprūpētai dzīvošanai.',
      airQuality: 'Iekštelpu gaisa kvalitātes monitorings',
      airQualityDesc: 'CO2 un vides monitorings ēkām un darba vietām.',
      smartOffice: 'Smart cities & critical infrastructures',
      smartOfficeDesc: 'Noslogojuma analītika un darba telpas optimizācija.',
      learnMore: 'Uzzināt vairāk',
    },
    // Specialized Solutions
    specialized: {
      label: 'Mūsu produkti',
      title: 'Specializēti IoT risinājumi',
      subtitle: 'Reāli IoT izvietojumi, ko izstrādājis un pārvalda 0g Baltics.',
      klinikTrack: 'Klinik Track',
      klinikTrackSub: 'Slimnīcas aktīvu izsekošana',
      klinikTrackDesc: 'Izsekojiet medicīnisko aprīkojumu un uzlabojiet slimnīcas loģistiku.',
      stickGo: 'Stick & Go',
      stickGoSub: 'Savienotais uzlīmes izsekotājs',
      stickGoDesc: 'Īpaši viegla IoT izsekošana aktīviem un loģistikai.',
      eldera: 'Eldera',
      elderaSub: 'Savienotā senioru aprūpe',
      elderaDesc: 'Sensori un uzraudzības risinājumi aprūpētai dzīvošanai un senioru drošībai.',
      smartParking: 'Viedā stāvvieta',
      smartParkingSub: 'Stāvvietu infrastruktūra',
      smartParkingDesc: 'Viedā stāvvietu infrastruktūra un noslogojuma monitorings.',
      pakuskapis: 'Pakuskapis',
      pakuskapisSub: 'Automatizēti pakomāti',
      pakuskapisDesc: 'Automatizēta pakomātu infrastruktūra pilsētām un loģistikas operatoriem.',
      bibliomats: 'Knygomatai / Bibliomats',
      bibliomatsSub: 'Viedie bibliotēkas skapīši',
      bibliomatsDesc: 'Viedās bibliotēkas skapīšu sistēmas automatizētai grāmatu saņemšanai un nodošanai.',
      smartEnergy: 'Viedais enerģijas monitorings',
      smartEnergySub: 'Enerģijas optimizācija',
      smartEnergyDesc: 'Attālināts enerģijas monitorings un optimizācija ēkām un infrastruktūrai.',
      medicalDevices: 'Medicīnas ierīces',
      medicalDevicesSub: 'E-veselības risinājumi',
      medicalDevicesDesc: 'Savienotās medicīnas ierīces un e-veselības infrastruktūra veselības aprūpes sniedzējiem.',
      toolTracking: 'Instrumentu izsekošana',
      toolTrackingSub: 'Industriālo instrumentu pārvaldība',
      toolTrackingDesc: 'Viedie skapīši, RFID izsekošana un automatizētas sadales sistēmas industriālajiem instrumentiem.',
      realEstate: 'Nekustamais īpašums un infrastruktūra',
      realEstateSub: 'Viedo ēku komplekts',
      realEstateDesc: 'Raktu-gatavs IoT nekustamā īpašuma attīstītājiem, īpašniekiem un aktīvu pārvaldniekiem — enerģija, noplūžu atklāšana, gaisa kvalitāte, aizņemtība un daudz kas cits.',
      e2Insurance: 'E2 Insurance',
      e2InsuranceSub: 'Ūdens noplūžu novēršana apdrošinātājiem',
      e2InsuranceDesc: 'Savienota risku novēršana apdrošināšanas sabiedrībām — atklājiet ūdens noplūdes agrāk, reaģējiet ātrāk un samaziniet zaudējumu apmēru.',
      newBadge: 'Jauns',
      visitWebsite: 'Apmeklēt vietni',
    },
    testimonials: {
      label: 'Atsauksmes',
      title: 'Ko saka mūsu klienti',
      subtitle: 'Atsauksmes no organizācijām, kas izmanto mūsu IoT risinājumus Baltijā.',
      q1: '0g Baltics palīdzēja mums pāriet no manuālas rādījumu nolasīšanas uz pilnīgu attālinātu uzraudzību. Ieviešana bija ātra, un dati ir uzticami jau no pirmās dienas.',
      r1: 'Operāciju vadītājs, komunālo pakalpojumu uzņēmums — Latvija',
      q2: 'Mēs beidzot redzam, kā mūsu ēkas patiešām darbojas. Enerģijas un gaisa kvalitātes dati palīdzēja samazināt izšķērdēšanu bez dārgas pārbūves.',
      r2: 'Ēku pārvaldības direktors, komerciālais nekustamais īpašums — Lietuva',
      q3: 'Pragmatisks partneris: viņi piedāvāja katram lietojumam piemērotāko tehnoloģiju, nevis uzspieda vienu produktu.',
      r3: 'Inovāciju vadītājs, pašvaldība — Igaunija',
    },
    // Tektelic Section
    tektelic: {
      label: 'LoRaWAN infrastruktūra',
      title: 'Operatoru klases LoRaWAN infrastruktūra ar',
      titleHighlight: 'Tektelic',
      description: '0g Baltics izvieto LoRaWAN tīklus, izmantojot Tektelic operatoru klases vārtejas un ierīces. Mūsu infrastruktūra ir izstrādāta uzticamībai, rūpnieciskiem izvietojumiem un liela mēroga pilsētu tīkliem.',
      feature1: 'Operatoru klases uzticamība',
      feature2: 'Rūpnieciski izvietojumi',
      feature3: 'Pilsētas mēroga tīkli',
      feature4: 'Liela mēroga infrastruktūra',
      cta: 'Izpētīt LoRaWAN infrastruktūru',
      partnerBadge: 'Autorizēts partneris',
    },
    // Viziosense Section
    viziosense: {
      label: 'Noslogojuma inteliģence',
      title: 'Noslogojuma inteliģence ar',
      titleHighlight: 'Viziosense',
      description: 'Viziosense malu AI sensori apvieno modernu datorredzi ar izturīgu aparatūras dizainu, nodrošinot precīzus, rentablus un privātuma aizsardzības risinājumus, kas rada ātru, izmērāmu ietekmi.',
      techSpecs: 'Tehniskās specifikācijas',
      sensitivity: 'Jutība',
      sensitivityDesc: 'Skaidra, uzticama redze īpaši zemā apgaismojumā',
      temperature: '0–95% RH',
      temperatureDesc: 'Izstrādāts, lai izturētu ekstremālus āra apstākļus',
      wideAngle: 'Platleņķa redze',
      wideAngleDesc: 'Maksimāls pārklājums, minimāli aklie punkti',
      productRange: 'Produktu klāsts',
      vizioPark: 'VizioPark',
      vizioParkDesc: 'Stāvvietu noslogojuma monitorings',
      vizioYard: 'VizioYard',
      vizioYardDesc: 'Āra pagalmu un loģistikas monitorings',
      vizioCount: 'VizioCount',
      vizioCountDesc: 'Sarkanās gaismas transportlīdzekļu skaitīšana',
      vizioCrowd: 'VizioCrowd',
      vizioCrowdDesc: 'Gājēju pārejas skaitīšana',
    },
    // Connectivity Section
    connectivity: {
      label: 'Savienojamība',
      title: 'Daudzlīmeņu IoT savienojamība',
      subtitle: 'Mēs izvēlamies visefektīvāko tīklu atkarībā no jūsu lietošanas gadījuma. Mūsu ekspertīze aptver vairākas savienojamības tehnoloģijas.',
      lorawan: 'LoRaWAN',
      lorawanDesc: 'Tāla darbības rādiusa, zema enerģijas patēriņa platjoslas tīkls IoT',
      lorawanF1: 'Līdz 15km rādiuss',
      lorawanF2: 'Zems enerģijas patēriņš',
      lorawanF3: 'Divvirzienu',
      sigfox: 'Sigfox',
      sigfoxDesc: 'Īpaši šauras joslas tehnoloģija vienkāršiem IoT ziņojumiem',
      sigfoxF1: 'Globāls pārklājums',
      sigfoxF2: 'Zemas izmaksas',
      sigfoxF3: 'Vienkārša integrācija',
      nbiot: 'NB-IoT',
      nbiotDesc: 'Šaurjoslas mobilā tehnoloģija IoT ierīcēm',
      nbiotF1: 'Dziļš iekštelpu pārklājums',
      nbiotF2: 'Operatoru klase',
      nbiotF3: 'Drošs',
      ble: 'BLE',
      bleDesc: 'Bluetooth Low Energy īsa darbības rādiusa savienojumam',
      bleF1: 'Iekštelpu pozicionēšana',
      bleF2: 'Aktīvu izsekošana',
      bleF3: 'Zems enerģijas patēriņš',
      satellite: 'Satelīts',
      satelliteDesc: 'Globāla savienojamība, ieskaitot Starlink saderību',
      satelliteF1: 'Attālas vietas',
      satelliteF2: 'Rezerves savienojamība',
      satelliteF3: 'Globāla sasniedzamība',
    },
    // Devices Section
    devices: {
      label: 'Ierīču ekosistēma',
      title: 'Labākās klases IoT ierīces',
      subtitle: 'Mēs sadarbojamies ar vadošajiem IoT ierīču ražotājiem, lai nodrošinātu uzticamus, rūpnieciskas klases risinājumus.',
      alsoPartnering: 'Arī sadarbojamies ar',
      andMore: 'un citiem.',
      technologyPartners: 'Tehnoloģiju partneri',
      deviceTypes: 'Ierīču veidi',
      networkTechnologies: 'Tīkla tehnoloģijas',
      balticCountries: 'Baltijas valstis',
    },
    // Customers Section
    customers: {
      label: 'Mums uzticas',
      title: 'Mūsu klienti',
    },
    // Deployments Section
    deployments: {
      label: 'Izvietojumi',
      title: 'Viņi izmanto 0g Baltics savienojamību',
      subtitle: 'Mūsu IoT infrastruktūra nodrošina darbību dažādās nozarēs, sniedzot uzticamību un izmērāmus rezultātus.',
      cities: 'Pilsētas un pašvaldības',
      citiesDesc: 'Viedās pilsētas infrastruktūra pilsētu pārvaldībai un sabiedriskajiem pakalpojumiem',
      utilities: 'Komunālie uzņēmumi',
      utilitiesDesc: 'Attālināta mērīšana un monitorings ūdenim, gāzei un elektrībai',
      buildings: 'Komerciālās ēkas',
      buildingsDesc: 'Noslogojuma monitorings, gaisa kvalitāte un enerģijas optimizācija',
      logistics: 'Loģistikas tīkli',
      logisticsDesc: 'Aktīvu izsekošana un autoparka pārvaldība piegādes ķēdēs',
      healthcare: 'Veselības aprūpes iestādes',
      healthcareDesc: 'Pacientu monitorings un aprīkojuma izsekošana aprūpes vidēs',
      trustStatement: 'Infrastruktūra, uz kuru varat paļauties.',
      trustStatementSub: 'Izveidota rūpnieciskām operācijām visā Baltijā.',
    },
    // Platforms Section
    platforms: {
      label: 'Platformu elastība',
      title: 'Atvērtās IoT platformas',
      subtitle: '0g Baltics atbalsta savas platformas, partneru platformas un trešo pušu integrācijas. Mēs nodrošinām, ka jūs nekad neesat ieslēgti vienā piegādātāja ekosistēmā.',
      noLockIn: 'Nav piegādātāja bloķēšanas',
      ownPlatform: '0g Baltics platforma',
      ownPlatformDesc: 'Mūsu patentētās backend un frontend platformas pilnīgai IoT pārvaldībai',
      partnerPlatforms: 'Partneru platformas',
      partnerPlatformsDesc: 'Netraucēta integrācija ar partneru ekosistēmām un esošo infrastruktūru',
      thirdParty: 'Trešo pušu integrācija',
      thirdPartyDesc: 'Atvērti API un standarta protokoli jebkurai platformas integrācijai',
    },
    // Consulting Section
    consulting: {
      label: 'Konsultācijas',
      title: 'Samaziniet darbības izmaksas ar',
      titleHighlight: 'IoT',
      subtitle: 'Mūsu konsultāciju pakalpojumi palīdz jums projektēt, plānot un izvietot IoT infrastruktūru, kas nodrošina izmērāmu izmaksu samazinājumu un darbības uzlabojumus.',
      service1: 'Infrastruktūras projektēšana',
      service2: 'Ierīču izvēle',
      service3: 'ROI modelēšana',
      service4: 'Pilotprojekti',
      service5: 'Izvietošanas stratēģija',
      roiFocus: 'Mēs koncentrējamies uz projektiem ar',
      months: 'mēneši',
      roiTarget: 'ROI atmaksas laiks',
      cta: 'Pieteikt konsultāciju',
    },
    // Infrastructure Section
    infrastructure: {
      label: 'Reģionālā ekspertīze',
      title: 'Veidojam IoT infrastruktūru visā Baltijā',
      subtitle: '0g Baltics strādā ar pilsētām, komunālajiem uzņēmumiem, rūpniecības kompānijām un integratoriem, lai izvietotu mērogojamu IoT infrastruktūru Lietuvā, Latvijā un Igaunijā.',
      cities: 'Pilsētas un pašvaldības',
      utilities: 'Komunālie un rūpniecība',
      integrators: 'Integratori un partneri',
    },
    // CTA Section
    cta: {
      title: 'Sāciet savu IoT projektu',
      subtitle: 'Gatavi samazināt darbības izmaksas un uzlabot efektivitāti? Pieteikties demonstrācijai, lai redzētu, kā IoT infrastruktūra var pārveidot jūsu darbību.',
      button: 'Pieteikt demonstrāciju',
    },
    // Contact Form
    contact: {
      label: 'Sazinieties ar mums',
      title: 'Apspriedīsim jūsu IoT projektu',
      subtitle: 'Neatkarīgi no tā, vai vēlaties izvietot viedo infrastruktūru, samazināt darbības izmaksas vai izpētīt IoT risinājumus, mēs esam šeit, lai palīdzētu.',
      email: 'E-pasts',
      whatToExpect: 'Ko gaidīt',
      expect1: 'Atbilde 24 darba stundu laikā',
      expect2: 'Sākotnējā konsultācija, lai izprastu jūsu vajadzības',
      expect3: 'Pielāgots risinājuma piedāvājums',
      fullName: 'Pilns vārds',
      company: 'Uzņēmums',
      phone: 'Tālrunis',
      country: 'Valsts',
      selectCountry: 'Izvēlieties valsti',
      interest: 'Interese',
      selectInterest: 'Kas jūs interesē?',
      message: 'Ziņojums',
      messagePlaceholder: 'Pastāstiet par savu projektu...',
      checkCity: 'Es pārstāvu pilsētu vai pašvaldību',
      checkIntegrator: 'Es esmu integrators / uzstādītājs',
      checkNewsletter: 'Es piekrītu saņemt jaunumus un atjauninājumus',
      checkAgree: 'Es piekrītu, ka ar mani sazinās',
      submit: 'Nosūtīt ziņojumu',
      sending: 'Nosūta...',
      thankYouTitle: 'Paldies, ka sazinājāties ar 0g Baltics',
      thankYouMessage: 'Mūsu komanda izskatīs jūsu pieprasījumu un drīzumā ar jums sazināsies.',
      errorAgree: 'Lūdzu, piekrītiet saziņai',
      errorRequired: 'Lūdzu, aizpildiet visus obligātos laukus',
      errorSubmit: 'Neizdevās iesniegt veidlapu. Lūdzu, mēģiniet vēlreiz.',
    },
    // Footer
    footer: {
      description: 'IoT infrastruktūra un viedie risinājumi Baltijai. Samazinām darbības izmaksas ar savienotām ierīcēm un viedo infrastruktūru.',
      navigation: 'Navigācija',
      legal: 'Juridiskā informācija',
      privacyPolicy: 'Privātuma politika',
      gdpr: 'GDPR',
      terms: 'Pakalpojumu noteikumi',
      imprint: 'Juridiskais paziņojums',
      offices: 'Mūsu biroji',
      copyright: '© 2026 0g Baltics. Visas tiesības aizsargātas.',
    },
    // Languages
    languages: {
      en: 'Angļu',
      lv: 'Latviešu',
      lt: 'Lietuviešu',
      ee: 'Igauņu',
      comingSoon: '',
    },
    // Interest options
    interests: {
      smartLockers: 'Viedie skapīši',
      smartMetering: 'Viedā mērīšana',
      assetTracking: 'Aktīvu izsekošana',
      elderlyCare: 'Senioru aprūpes risinājumi',
      airQuality: 'Iekštelpu gaisa kvalitātes monitorings',
      energyMonitoring: 'Enerģijas monitorings',
      officeManagement: 'Biroja telpu vadība',
      connectivity: 'Savienojamības infrastruktūra',
      tektelic: 'Tektelic vārtejas',
      consulting: 'Izmaksu samazināšanas konsultācijas',
    },
    // Countries
    countries: {
      lithuania: 'Lietuva',
      latvia: 'Latvija',
      estonia: 'Igaunija',
      poland: 'Polija',
      finland: 'Somija',
      sweden: 'Zviedrija',
      germany: 'Vācija',
      other: 'Cita',
    },
  },
  
  lt: {
    // Header & Navigation
    nav: {
      solutions: 'Sprendimai',
      solutionsMenu: 'Sprendimai',
      products: 'Produktai',
      company: 'Įmonė',
      blog: 'Tinklaraštis',
      balticHub: 'Hub 2026',
      balticHubBadge: 'NAUJA',
      infrastructure: 'Infrastruktūra',
      devices: 'Įrenginiai',
      partners: 'Partneriai',
      consulting: 'Konsultacijos',
      industries: 'Pramonės šakos',
      about: 'Apie mus',
      contact: 'Kontaktai',
      scheduleDemo: 'Užsisakyti demonstraciją',
      // Solutions dropdown items
      smartMetering: 'Išmanusis matavimas',
      assetTracking: 'Turto sekimas',
      toolTracking: 'Įrankių sekimas',
      indoorAirQuality: 'Vidaus oro kokybė',
      smartLockers: 'Išmaniosios spintelės',
      buildingEnergy: 'Pastatų energetika',
      officeSpace: 'Biuro erdvės',
      smartCities: 'Išmanieji miestai',
      realEstate: 'Nekilnojamasis turtas ir infrastruktūra',
      iotSolutions: 'IoT sprendimai',
      // Products dropdown items
      tektelic: 'TEKTELIC',
      tektelicDesc: 'LoRaWAN infrastruktūra',
      connectivity: 'Ryšio sprendimai',
      connectivityDesc: 'Tinklo sprendimai',
      hardwareInfra: 'Techninė įranga ir infrastruktūra',
    },
    // Blog Page
    blog: {
      badge: 'Tinklaraštis ir įžvalgos',
      title: 'IoT žinių centras',
      subtitle: 'Tyrinėkite straipsnius, vadovus ir atvejų tyrimus apie LoRaWAN infrastruktūrą, išmaniuosius miestus, vidaus oro kokybės stebėseną ir pramoninius IoT sprendimus.',
      all: 'Visi',
      smartCities: 'Išmanieji miestai',
      indoorAirQuality: 'Vidaus oro kokybė',
      smartMetering: 'Išmanusis matavimas',
      assetTracking: 'Turto sekimas',
      energyEfficiency: 'Energetinis efektyvumas',
      productReviews: 'Produktų apžvalgos',
      readMore: 'Skaityti daugiau',
      loadMore: 'Įkelti daugiau straipsnių',
      minRead: 'min skaitymo',
      newsletterBadge: 'Būkite informuoti',
      newsletterTitle: 'Prenumeruokite mūsų naujienlaiškį',
      newsletterSubtitle: 'Gaukite naujausias IoT įžvalgas, atvejų tyrimus ir produktų naujienas kas mėnesį.',
      newsletterPlaceholder: 'Įveskite savo el. paštą',
      newsletterButton: 'Prenumeruoti',
      newsletterDisclaimer: 'Jokio šlamšto. Bet kada galite atsisakyti.',
      // Sample articles
      article1Title: 'Keičiamos LoRaWAN infrastruktūros kūrimas išmaniesiems miestams',
      article1Excerpt: 'Kaip Baltijos šalių miestai diegia LoRaWAN tinklus išmaniajam matavimui, aplinkos stebėsenai ir sujungtai infrastruktūrai.',
      article2Title: 'Vidaus oro kokybės stebėsena mokyklose: išsamus vadovas',
      article2Excerpt: 'Kodėl CO2 stebėsena svarbi mokinių sveikatai ir rezultatams, ir kaip įdiegti efektyvias IAQ sistemas švietimo įstaigose.',
      article3Title: 'Išmanusis matavimas komunalinėms įmonėms: investicijų grąža ir diegimo praktika',
      article3Excerpt: 'Išsami apžvalga, kaip komunalinės įmonės naudoja IoT išmaniuosius skaitiklius efektyvumui gerinti.',
      article4Title: 'Realaus laiko turto sekimas logistikoje: LoRaWAN prieš GPS',
      article4Excerpt: 'Ryšio parinkčių palyginimas turto sekimui logistikos operacijose.',
      article5Title: 'Kaip IoT jutikliai sumažina pastatų energijos suvartojimą 30%',
      article5Excerpt: 'Atvejų tyrimai ir techniniai sprendimai naudojant sujungtus jutiklius HVAC optimizavimui.',
      article6Title: 'TEKTELIC BREEZE: išsami CO2 išmaniojo patalpos jutiklio apžvalga',
      article6Excerpt: 'Detali TEKTELIC BREEZE jutiklių šeimos apžvalga, įskaitant specifikacijas ir diegimo scenarijus.',
    },
    // Hero Section
    hero: {
      badge: 'IoT sprendimų teikėjas',
      title: 'IoT infrastruktūra ir išmanieji sprendimai',
      titleHighlight: 'Baltijos šalims',
      subtitle: 'Padedame miestams, komunalinėms įmonėms ir kompanijoms diegti IoT infrastruktūrą, kuri mažina veiklos sąnaudas.',
      ctaPrimary: 'Užsisakyti demonstraciją',
      ctaSecondary: 'Tyrinėti sprendimus',
      trustedTech: 'Patikimos technologijos',
      yearsExp: 'Metų IoT patirties',
      deployedDevices: 'Įdiegtų IoT įrenginių',
      balticCountries: 'Baltijos šalys',
    },
    // Solutions Section
    solutions: {
      label: 'Sprendimai',
      title: 'IoT sprendimai',
      subtitle: 'Išsamūs IoT sprendimai, sukurti mažinti veiklos sąnaudas ir didinti efektyvumą įvairiose pramonės šakose.',
      smartLockers: 'Išmaniosios spintelės',
      smartLockersDesc: 'Automatizuota spintelių infrastruktūra logistikai, biurams ir viešosioms paslaugoms.',
      smartMetering: 'Išmanusis matavimas',
      smartMeteringDesc: 'Operatorių klasės šliuzai ir nuotolinis duomenų rinkimas komunalinėms paslaugoms.',
      assetTracking: 'Turto sekimas',
      assetTrackingDesc: 'Vidaus ir lauko sekimas naudojant LoRaWAN, Sigfox, NB-IoT, BLE ir palydovinį ryšį.',
      elderlyCare: 'Senelių priežiūros sprendimai',
      elderlyCareDesc: 'Sujungti jutikliai ir stebėjimo technologijos pagalbiniam gyvenimui.',
      airQuality: 'Vidaus oro kokybės stebėsena',
      airQualityDesc: 'CO2 ir aplinkos stebėsena pastatams ir darbo vietoms.',
      smartOffice: 'Smart cities & critical infrastructures',
      smartOfficeDesc: 'Užimtumo analitika ir darbo erdvės optimizavimas.',
      learnMore: 'Sužinoti daugiau',
    },
    // Specialized Solutions
    specialized: {
      label: 'Mūsų produktai',
      title: 'Specializuoti IoT sprendimai',
      subtitle: 'Realūs IoT diegimai, kuriuos sukūrė ir valdo 0g Baltics.',
      klinikTrack: 'Klinik Track',
      klinikTrackSub: 'Ligoninės turto sekimas',
      klinikTrackDesc: 'Sekite medicinos įrangą ir tobulinkite ligoninės logistiką.',
      stickGo: 'Stick & Go',
      stickGoSub: 'Sujungtas lipduko sekiklis',
      stickGoDesc: 'Itin lengvas IoT sekimas turtui ir logistikai.',
      eldera: 'Eldera',
      elderaSub: 'Sujungta senelių priežiūra',
      elderaDesc: 'Jutikliai ir stebėjimo sprendimai pagalbiniam gyvenimui ir senelių saugumui.',
      smartParking: 'Išmanusis parkavimas',
      smartParkingSub: 'Parkavimo infrastruktūra',
      smartParkingDesc: 'Išmani parkavimo infrastruktūra ir užimtumo stebėsena.',
      pakuskapis: 'Pakuskapis',
      pakuskapisSub: 'Automatizuotos siuntų spintelės',
      pakuskapisDesc: 'Automatizuota siuntų spintelių infrastruktūra miestams ir logistikos operatoriams.',
      bibliomats: 'Knygomatai / Bibliomats',
      bibliomatsSub: 'Išmaniosios bibliotekos spintelės',
      bibliomatsDesc: 'Išmanios bibliotekos spintelių sistemos automatiniam knygų atsiėmimui ir grąžinimui.',
      smartEnergy: 'Išmanus energijos stebėjimas',
      smartEnergySub: 'Energijos optimizavimas',
      smartEnergyDesc: 'Nuotolinis energijos stebėjimas ir optimizavimas pastatams ir infrastruktūrai.',
      medicalDevices: 'Medicinos prietaisai',
      medicalDevicesSub: 'E-sveikatos sprendimai',
      medicalDevicesDesc: 'Sujungti medicinos prietaisai ir e-sveikatos infrastruktūra sveikatos priežiūros teikėjams.',
      toolTracking: 'Įrankių sekimas',
      toolTrackingSub: 'Pramoninių įrankių valdymas',
      toolTrackingDesc: 'Išmanios spintelės, RFID sekimas ir automatizuotos paskirstymo sistemos pramoniniams įrankiams.',
      realEstate: 'Nekilnojamasis turtas ir infrastruktūra',
      realEstateSub: 'Išmaniųjų pastatų rinkinys',
      realEstateDesc: 'Raktų perdavimo IoT nekilnojamojo turto plėtotojams, savininkams ir turto valdytojams — energija, nuotėkių aptikimas, oro kokybė, užimtumas ir daugiau.',
      e2Insurance: 'E2 Insurance',
      e2InsuranceSub: 'Vandens nuotėkių prevencija draudikams',
      e2InsuranceDesc: 'Sujungta rizikos prevencija draudimo bendrovėms — aptikite vandens nuotėkius anksčiau, reaguokite greičiau ir sumažinkite žalos mastą.',
      newBadge: 'Nauja',
      visitWebsite: 'Apsilankyti svetainėje',
    },
    testimonials: {
      label: 'Atsiliepimai',
      title: 'Ką sako mūsų klientai',
      subtitle: 'Organizacijų, naudojančių mūsų IoT sprendimus Baltijos šalyse, atsiliepimai.',
      q1: '0g Baltics padėjo mums pereiti nuo rankinio rodmenų nuskaitymo prie visiškos nuotolinės stebėsenos. Diegimas buvo greitas, o duomenys patikimi nuo pirmos dienos.',
      r1: 'Operacijų vadovas, komunalinių paslaugų įmonė — Latvija',
      q2: 'Pagaliau matome, kaip iš tikrųjų veikia mūsų pastatai. Energijos ir oro kokybės duomenys padėjo sumažinti švaistymą be brangios renovacijos.',
      r2: 'Pastatų ūkio direktorius, komercinis nekilnojamasis turtas — Lietuva',
      q3: 'Pragmatiškas partneris: kiekvienam atvejui pasiūlė tinkamiausią technologiją, o ne stūmė vieną produktą.',
      r3: 'Inovacijų vadovas, savivaldybė — Estija',
    },
    // Tektelic Section
    tektelic: {
      label: 'LoRaWAN infrastruktūra',
      title: 'Operatorių klasės LoRaWAN infrastruktūra su',
      titleHighlight: 'Tektelic',
      description: '0g Baltics diegia LoRaWAN tinklus naudodama Tektelic operatorių klasės šliuzus ir įrenginius. Mūsų infrastruktūra sukurta patikimumui, pramoniniams diegimams ir didelio masto miestų tinklams.',
      feature1: 'Operatorių klasės patikimumas',
      feature2: 'Pramoniniai diegimai',
      feature3: 'Miesto masto tinklai',
      feature4: 'Didelio masto infrastruktūra',
      cta: 'Tyrinėti LoRaWAN infrastruktūrą',
      partnerBadge: 'Įgaliotas partneris',
    },
    // Viziosense Section
    viziosense: {
      label: 'Užimtumo intelektas',
      title: 'Užimtumo intelektas su',
      titleHighlight: 'Viziosense',
      description: 'Viziosense krašto AI jutikliai sujungia pažangią kompiuterinę regą su tvirtu aparatūros dizainu, teikdami tikslius, ekonomiškai efektyvius ir privatumą prioritetizuojančius sprendimus, kurie sukuria greitą, išmatuojamą poveikį.',
      techSpecs: 'Techninės specifikacijos',
      sensitivity: 'Jautrumas',
      sensitivityDesc: 'Aiški, patikima rega itin silpnoje šviesoje',
      temperature: '0–95% RH',
      temperatureDesc: 'Sukurta atlaikyti ekstremalias lauko sąlygas',
      wideAngle: 'Plačiakampė rega',
      wideAngleDesc: 'Maksimalus aprėptis, minimalios aklosios zonos',
      productRange: 'Produktų asortimentas',
      vizioPark: 'VizioPark',
      vizioParkDesc: 'Parkavimo užimtumo stebėsena',
      vizioYard: 'VizioYard',
      vizioYardDesc: 'Lauko kiemų ir logistikos stebėsena',
      vizioCount: 'VizioCount',
      vizioCountDesc: 'Raudonos šviesos transporto priemonių skaičiavimas',
      vizioCrowd: 'VizioCrowd',
      vizioCrowdDesc: 'Pėsčiųjų perėjos skaičiavimas',
    },
    // Connectivity Section
    connectivity: {
      label: 'Ryšys',
      title: 'Daugiatinklis IoT ryšys',
      subtitle: 'Parenkame efektyviausią tinklą pagal jūsų naudojimo atvejį. Mūsų ekspertizė apima kelias ryšio technologijas.',
      lorawan: 'LoRaWAN',
      lorawanDesc: 'Tolimojo nuotolio, mažo energijos suvartojimo plačiajuostis tinklas IoT',
      lorawanF1: 'Iki 15km atstumas',
      lorawanF2: 'Mažas energijos suvartojimas',
      lorawanF3: 'Dvikryptis',
      sigfox: 'Sigfox',
      sigfoxDesc: 'Itin siaurajuostė technologija paprastiems IoT pranešimams',
      sigfoxF1: 'Globalus aprėptis',
      sigfoxF2: 'Mažos išlaidos',
      sigfoxF3: 'Paprastas integravimas',
      nbiot: 'NB-IoT',
      nbiotDesc: 'Siaurajuostė mobilioji technologija IoT įrenginiams',
      nbiotF1: 'Gilus patalpų aprėptis',
      nbiotF2: 'Operatorių klasė',
      nbiotF3: 'Saugus',
      ble: 'BLE',
      bleDesc: 'Bluetooth Low Energy trumpojo nuotolio ryšiui',
      bleF1: 'Patalpų pozicionavimas',
      bleF2: 'Turto sekimas',
      bleF3: 'Mažas energijos suvartojimas',
      satellite: 'Palydovas',
      satelliteDesc: 'Globalus ryšys, įskaitant Starlink suderinamumą',
      satelliteF1: 'Nuošalios vietovės',
      satelliteF2: 'Atsarginis ryšys',
      satelliteF3: 'Globalus pasiekiamumas',
    },
    // Devices Section
    devices: {
      label: 'Įrenginių ekosistema',
      title: 'Geriausios klasės IoT įrenginiai',
      subtitle: 'Bendradarbiaujame su pirmaujančiais IoT įrenginių gamintojais, kad teiktume patikimus, pramoninio lygio sprendimus.',
      alsoPartnering: 'Taip pat bendradarbiaujame su',
      andMore: 'ir kitais.',
      technologyPartners: 'Technologijų partneriai',
      deviceTypes: 'Įrenginių tipai',
      networkTechnologies: 'Tinklo technologijos',
      balticCountries: 'Baltijos šalys',
    },
    // Customers Section
    customers: {
      label: 'Mumis pasitiki',
      title: 'Mūsų klientai',
    },
    // Deployments Section
    deployments: {
      label: 'Diegimai',
      title: 'Jie naudoja 0g Baltics ryšį',
      subtitle: 'Mūsų IoT infrastruktūra užtikrina operacijas įvairiose pramonės šakose, teikdama patikimumą ir išmatuojamus rezultatus.',
      cities: 'Miestai ir savivaldybės',
      citiesDesc: 'Išmaniojo miesto infrastruktūra miestų valdymui ir viešosioms paslaugoms',
      utilities: 'Komunalinės įmonės',
      utilitiesDesc: 'Nuotolinis matavimas ir stebėsena vandeniui, dujoms ir elektrai',
      buildings: 'Komerciniai pastatai',
      buildingsDesc: 'Užimtumo stebėsena, oro kokybė ir energijos optimizavimas',
      logistics: 'Logistikos tinklai',
      logisticsDesc: 'Turto sekimas ir autoparkų valdymas tiekimo grandinėse',
      healthcare: 'Sveikatos priežiūros įstaigos',
      healthcareDesc: 'Pacientų stebėsena ir įrangos sekimas priežiūros aplinkose',
      trustStatement: 'Infrastruktūra, kuria galite pasitikėti.',
      trustStatementSub: 'Sukurta pramoninėms operacijoms visoje Baltijoje.',
    },
    // Platforms Section
    platforms: {
      label: 'Platformų lankstumas',
      title: 'Atviros IoT platformos',
      subtitle: '0g Baltics palaiko savo platformas, partnerių platformas ir trečiųjų šalių integracijas. Užtikriname, kad niekada nebūsite užrakinti vieno tiekėjo ekosistemoje.',
      noLockIn: 'Jokio tiekėjo užrakinimo',
      ownPlatform: '0g Baltics platforma',
      ownPlatformDesc: 'Mūsų patentuotos backend ir frontend platformos pilnam IoT valdymui',
      partnerPlatforms: 'Partnerių platformos',
      partnerPlatformsDesc: 'Sklandi integracija su partnerių ekosistemomis ir esama infrastruktūra',
      thirdParty: 'Trečiųjų šalių integracija',
      thirdPartyDesc: 'Atviri API ir standartiniai protokolai bet kokiai platformos integracijai',
    },
    // Consulting Section
    consulting: {
      label: 'Konsultacijos',
      title: 'Sumažinkite veiklos sąnaudas su',
      titleHighlight: 'IoT',
      subtitle: 'Mūsų konsultacinės paslaugos padeda jums projektuoti, planuoti ir diegti IoT infrastruktūrą, kuri užtikrina išmatuojamą sąnaudų mažinimą ir veiklos patobulinimus.',
      service1: 'Infrastruktūros projektavimas',
      service2: 'Įrenginių parinkimas',
      service3: 'ROI modeliavimas',
      service4: 'Pilotiniai projektai',
      service5: 'Diegimo strategija',
      roiFocus: 'Mes koncentruojamės į projektus su',
      months: 'mėnesiai',
      roiTarget: 'ROI atsipirkimo laikas',
      cta: 'Užsisakyti konsultaciją',
    },
    // Infrastructure Section
    infrastructure: {
      label: 'Regioninė ekspertizė',
      title: 'Kuriame IoT infrastruktūrą visoje Baltijoje',
      subtitle: '0g Baltics dirba su miestais, komunalinėmis įmonėmis, pramonės kompanijomis ir integratoriais, kad diegtų keičiamo masto IoT infrastruktūrą Lietuvoje, Latvijoje ir Estijoje.',
      cities: 'Miestai ir savivaldybės',
      utilities: 'Komunalinės ir pramonė',
      integrators: 'Integratoriai ir partneriai',
    },
    // CTA Section
    cta: {
      title: 'Pradėkite savo IoT projektą',
      subtitle: 'Pasiruošę sumažinti veiklos sąnaudas ir pagerinti efektyvumą? Užsisakykite demonstraciją, kad pamatytumėte, kaip IoT infrastruktūra gali transformuoti jūsų operacijas.',
      button: 'Užsisakyti demonstraciją',
    },
    // Contact Form
    contact: {
      label: 'Susisiekite su mumis',
      title: 'Aptarkime jūsų IoT projektą',
      subtitle: 'Nesvarbu, ar norite diegti išmaniąją infrastruktūrą, mažinti veiklos sąnaudas ar tyrinėti IoT sprendimus, mes esame čia padėti.',
      email: 'El. paštas',
      whatToExpect: 'Ko tikėtis',
      expect1: 'Atsakymas per 24 darbo valandas',
      expect2: 'Pradinė konsultacija jūsų poreikiams suprasti',
      expect3: 'Pritaikytas sprendimo pasiūlymas',
      fullName: 'Pilnas vardas',
      company: 'Įmonė',
      phone: 'Telefonas',
      country: 'Šalis',
      selectCountry: 'Pasirinkite šalį',
      interest: 'Domina',
      selectInterest: 'Kas jus domina?',
      message: 'Žinutė',
      messagePlaceholder: 'Papasakokite apie savo projektą...',
      checkCity: 'Atstovauju miestą arba savivaldybę',
      checkIntegrator: 'Esu integratorius / diegėjas',
      checkNewsletter: 'Sutinku gauti naujienlaiškius ir atnaujinimus',
      checkAgree: 'Sutinku, kad su manimi susisiektų',
      submit: 'Siųsti žinutę',
      sending: 'Siunčiama...',
      thankYouTitle: 'Dėkojame, kad susisiekėte su 0g Baltics',
      thankYouMessage: 'Mūsų komanda peržiūrės jūsų užklausą ir netrukus su jumis susisieks.',
      errorAgree: 'Prašome sutikti su susisiekimu',
      errorRequired: 'Prašome užpildyti visus privalomus laukus',
      errorSubmit: 'Nepavyko pateikti formos. Bandykite dar kartą.',
    },
    // Footer
    footer: {
      description: 'IoT infrastruktūra ir išmanieji sprendimai Baltijai. Mažiname veiklos sąnaudas sujungtais įrenginiais ir išmaniąja infrastruktūra.',
      navigation: 'Navigacija',
      legal: 'Teisinė informacija',
      privacyPolicy: 'Privatumo politika',
      gdpr: 'BDAR',
      terms: 'Paslaugų sąlygos',
      imprint: 'Teisinis pranešimas',
      offices: 'Mūsų biurai',
      copyright: '© 2026 0g Baltics. Visos teisės saugomos.',
    },
    // Languages
    languages: {
      en: 'Anglų',
      lv: 'Latvių',
      lt: 'Lietuvių',
      ee: 'Estų',
      comingSoon: '',
    },
    // Interest options
    interests: {
      smartLockers: 'Išmaniosios spintelės',
      smartMetering: 'Išmanusis matavimas',
      assetTracking: 'Turto sekimas',
      elderlyCare: 'Senelių priežiūros sprendimai',
      airQuality: 'Vidaus oro kokybės stebėsena',
      energyMonitoring: 'Energijos stebėsena',
      officeManagement: 'Biuro erdvių valdymas',
      connectivity: 'Ryšio infrastruktūra',
      tektelic: 'Tektelic šliuzai',
      consulting: 'Sąnaudų mažinimo konsultacijos',
    },
    // Countries
    countries: {
      lithuania: 'Lietuva',
      latvia: 'Latvija',
      estonia: 'Estija',
      poland: 'Lenkija',
      finland: 'Suomija',
      sweden: 'Švedija',
      germany: 'Vokietija',
      other: 'Kita',
    },
  },
  
  ee: {
    // Header & Navigation
    nav: {
      solutions: 'Lahendused',
      solutionsMenu: 'Lahendused',
      products: 'Tooted',
      company: 'Ettevõte',
      blog: 'Blogi',
      balticHub: 'Hub 2026',
      balticHubBadge: 'UUS',
      infrastructure: 'Infrastruktuur',
      devices: 'Seadmed',
      partners: 'Partnerid',
      consulting: 'Konsultatsioon',
      industries: 'Tööstusharud',
      about: 'Meist',
      contact: 'Kontakt',
      scheduleDemo: 'Broneeri demo',
      // Solutions dropdown items
      smartMetering: 'Nutikas mõõtmine',
      assetTracking: 'Varade jälgimine',
      toolTracking: 'Tööriistade jälgimine',
      indoorAirQuality: 'Siseõhu kvaliteet',
      smartLockers: 'Nutikad kapid',
      buildingEnergy: 'Hoonete energia',
      officeSpace: 'Kontoriruumid',
      smartCities: 'Nutikad linnad',
      realEstate: 'Kinnisvara ja infrastruktuur',
      iotSolutions: 'IoT lahendused',
      // Products dropdown items
      tektelic: 'TEKTELIC',
      tektelicDesc: 'LoRaWAN infrastruktuur',
      connectivity: 'Ühenduvus',
      connectivityDesc: 'Võrgulahendused',
      hardwareInfra: 'Riistvara ja infrastruktuur',
    },
    // Blog Page
    blog: {
      badge: 'Blogi ja ülevaated',
      title: 'IoT teadmuskeskus',
      subtitle: 'Tutvu artiklite, juhendite ja juhtumiuuringutega LoRaWAN infrastruktuuri, nutikate linnade, siseõhu kvaliteedi seire ja tööstuslike IoT lahenduste kohta.',
      all: 'Kõik',
      smartCities: 'Nutikad linnad',
      indoorAirQuality: 'Siseõhu kvaliteet',
      smartMetering: 'Nutikas mõõtmine',
      assetTracking: 'Varade jälgimine',
      energyEfficiency: 'Energiatõhusus',
      productReviews: 'Tootearvustused',
      readMore: 'Loe edasi',
      loadMore: 'Laadi veel artikleid',
      minRead: 'min lugemist',
      newsletterBadge: 'Ole kursis',
      newsletterTitle: 'Telli meie uudiskiri',
      newsletterSubtitle: 'Saa uusimad IoT ülevaated, juhtumiuuringud ja tooteuudised iga kuu oma postkasti.',
      newsletterPlaceholder: 'Sisesta oma e-post',
      newsletterButton: 'Telli',
      newsletterDisclaimer: 'Mingit rämpsposti. Saad igal ajal loobuda.',
      // Sample articles
      article1Title: 'Skaleeritava LoRaWAN infrastruktuuri loomine nutikatele linnadele',
      article1Excerpt: 'Kuidas Baltimaade linnad juurutavad LoRaWAN võrke nutika mõõtmise, keskkonnaseire ja ühendatud infrastruktuuri jaoks.',
      article2Title: 'Siseõhu kvaliteedi seire koolides: täielik juhend',
      article2Excerpt: 'Miks CO2 seire on oluline õpilaste tervisele ja tulemustele ning kuidas juurutada tõhusaid IAQ süsteeme haridusasutustes.',
      article3Title: 'Nutikas mõõtmine kommunaalettevõtetele: investeeringutasuvus ja juurutamise parimad tavad',
      article3Excerpt: 'Põhjalik ülevaade, kuidas kommunaalettevõtted kasutavad IoT-põhiseid nutikaid arvesteid tõhususe parandamiseks.',
      article4Title: 'Reaalajas varade jälgimine logistikas: LoRaWAN vs GPS',
      article4Excerpt: 'Ühenduvusvalikute võrdlus varade jälgimiseks logistikaoperatsioonides.',
      article5Title: 'Kuidas IoT andurid vähendavad hoonete energiatarbimist 30%',
      article5Excerpt: 'Juhtumiuuringud ja tehnilised lähenemisviisid ühendatud andurite kasutamiseks HVAC optimeerimiseks.',
      article6Title: 'TEKTELIC BREEZE: CO2 nutika ruumianduuri põhjalik ülevaade',
      article6Excerpt: 'Üksikasjalik ülevaade TEKTELIC BREEZE anduriperekonnast, sealhulgas spetsifikatsioonid ja juurutusstsenaariumid.',
    },
    // Hero Section
    hero: {
      badge: 'IoT lahenduste pakkuja',
      title: 'IoT infrastruktuur ja nutikad lahendused',
      titleHighlight: 'Baltimaadele',
      subtitle: 'Aitame linnadel, kommunaalettevõtetel ja ettevõtetel juurutada IoT infrastruktuuri, mis vähendab tegevuskulusid.',
      ctaPrimary: 'Broneeri demo',
      ctaSecondary: 'Tutvu lahendustega',
      trustedTech: 'Usaldusväärsed tehnoloogiad',
      yearsExp: 'Aastat IoT kogemust',
      deployedDevices: 'Paigaldatud IoT seadet',
      balticCountries: 'Balti riiki',
    },
    // Solutions Section
    solutions: {
      label: 'Lahendused',
      title: 'IoT lahendused',
      subtitle: 'Põhjalikud IoT lahendused, mis on loodud vähendama tegevuskulusid ja parandama efektiivsust erinevates tööstusharudes.',
      smartLockers: 'Nutikad kapid',
      smartLockersDesc: 'Automatiseeritud kapitaristu logistikale, kontoritele ja avalikele teenustele.',
      smartMetering: 'Nutikas mõõtmine',
      smartMeteringDesc: 'Operaatoriklassi lüüsid ja kaugandmete kogumine kommunaalteenustele.',
      assetTracking: 'Varade jälgimine',
      assetTrackingDesc: 'Sise- ja välisjälgimine kasutades LoRaWAN, Sigfox, NB-IoT, BLE ja satelliitühendust.',
      elderlyCare: 'Eakate hoolduse lahendused',
      elderlyCareDesc: 'Ühendatud andurid ja seiretehnoloogiad toetatud elamiseks.',
      airQuality: 'Siseõhu kvaliteedi seire',
      airQualityDesc: 'CO2 ja keskkonnaseire hoonetele ja töökohtadele.',
      smartOffice: 'Smart cities & critical infrastructures',
      smartOfficeDesc: 'Täituvuse analüütika ja tööruumi optimeerimine.',
      learnMore: 'Loe lähemalt',
    },
    // Specialized Solutions
    specialized: {
      label: 'Meie tooted',
      title: 'Spetsialiseeritud IoT lahendused',
      subtitle: 'Reaalsed IoT juurutused, mille on välja töötanud ja mida haldab 0g Baltics.',
      klinikTrack: 'Klinik Track',
      klinikTrackSub: 'Haigla varade jälgimine',
      klinikTrackDesc: 'Jälgige meditsiiniseadmeid ja parandage haigla logistikat.',
      stickGo: 'Stick & Go',
      stickGoSub: 'Ühendatud kleepsuv jälgija',
      stickGoDesc: 'Ültrakerge IoT jälgimine varadele ja logistikale.',
      eldera: 'Eldera',
      elderaSub: 'Ühendatud eakate hooldus',
      elderaDesc: 'Andurid ja seirelahendused toetatud elamiseks ja eakate ohutuseks.',
      smartParking: 'Nutikas parkimine',
      smartParkingSub: 'Parkimistaristu',
      smartParkingDesc: 'Nutikas parkimistaristu ja täituvuse seire.',
      pakuskapis: 'Pakuskapis',
      pakuskapisSub: 'Automatiseeritud pakikapid',
      pakuskapisDesc: 'Automatiseeritud pakikapitaristu linnadele ja logistikaoperaatoritele.',
      bibliomats: 'Knygomatai / Bibliomats',
      bibliomatsSub: 'Nutikad raamatukogu kapid',
      bibliomatsDesc: 'Nutikad raamatukogu kapisüsteemid automaatseks raamatute kättesaamiseks ja tagastamiseks.',
      smartEnergy: 'Nutikas energiaseire',
      smartEnergySub: 'Energia optimeerimine',
      smartEnergyDesc: 'Kaugenergiaseire ja optimeerimine hoonetele ja infrastruktuurile.',
      medicalDevices: 'Meditsiiniseadmed',
      medicalDevicesSub: 'E-tervise lahendused',
      medicalDevicesDesc: 'Ühendatud meditsiiniseadmed ja e-tervise taristu tervishoiuteenuste pakkujatele.',
      toolTracking: 'Tööriistade jälgimine',
      toolTrackingSub: 'Tööstuslike tööriistade haldamine',
      toolTrackingDesc: 'Nutikad kapid, RFID jälgimine ja automatiseeritud jaotussüsteemid tööstuslikele tööriistadele.',
      realEstate: 'Kinnisvara ja infrastruktuur',
      realEstateSub: 'Nutikate hoonete komplekt',
      realEstateDesc: 'Võtmed-kätte IoT kinnisvara arendajatele, omanikele ja varahalduritele — energia, lekete tuvastamine, õhukvaliteet, hõivatus ja palju muud.',
      e2Insurance: 'E2 Insurance',
      e2InsuranceSub: 'Veelekete ennetus kindlustusandjatele',
      e2InsuranceDesc: 'Ühendatud riskiennetus kindlustusseltsidele — tuvastage veelekked varem, reageerige kiiremini ja vähendage kahjude ulatust.',
      newBadge: 'Uus',
      visitWebsite: 'Külasta veebilehte',
    },
    testimonials: {
      label: 'Tagasiside',
      title: 'Mida meie kliendid ütlevad',
      subtitle: 'Tagasiside organisatsioonidelt, kes kasutavad meie IoT-lahendusi Baltikumis.',
      q1: '0g Baltics aitas meil liikuda käsitsi näitude lugemiselt täielikule kaugseirele. Juurutamine oli kiire ja andmed on olnud usaldusväärsed esimesest päevast.',
      r1: 'Operatsioonijuht, kommunaalettevõte — Läti',
      q2: 'Lõpuks näeme, kuidas meie hooned tegelikult toimivad. Energia- ja õhukvaliteedi andmed aitasid vähendada raiskamist ilma kuluka renoveerimiseta.',
      r2: 'Haldusdirektor, ärikinnisvara — Leedu',
      q3: 'Pragmaatiline partner: nad pakkusid igale kasutusjuhule sobivaima tehnoloogia, mitte ei surunud peale ühte toodet.',
      r3: 'Innovatsioonijuht, omavalitsus — Eesti',
    },
    // Tektelic Section
    tektelic: {
      label: 'LoRaWAN infrastruktuur',
      title: 'Operaatoriklassi LoRaWAN infrastruktuur',
      titleHighlight: 'Tektelic',
      description: '0g Baltics juurutab LoRaWAN võrke kasutades Tektelic operaatoriklassi lüüse ja seadmeid. Meie infrastruktuur on loodud töökindluseks, tööstuslikeks juurutusteks ja suuremahuliste linnavõrkude jaoks.',
      feature1: 'Operaatoriklassi töökindlus',
      feature2: 'Tööstuslikud juurutused',
      feature3: 'Linnalai võrgud',
      feature4: 'Suuremahuline taristu',
      cta: 'Tutvu LoRaWAN taristuga',
      partnerBadge: 'Volitatud partner',
    },
    // Viziosense Section
    viziosense: {
      label: 'Täituvuse luure',
      title: 'Täituvuse luure',
      titleHighlight: 'Viziosense',
      description: 'Viziosense serva AI andurid ühendavad tipptasemel arvutinägemise tugeva riistvaradisainiga, pakkudes täpseid, kulutõhusaid ja privaatsust eelistavaid lahendusi, mis loovad kiiret, mõõdetavat mõju.',
      techSpecs: 'Tehnilised andmed',
      sensitivity: 'Tundlikkus',
      sensitivityDesc: 'Selge, usaldusväärne nägemine ülimadalas valguses',
      temperature: '0–95% RH',
      temperatureDesc: 'Loodud taluma äärmuslikke välistingimusi',
      wideAngle: 'Lainurknägemine',
      wideAngleDesc: 'Maksimaalne katvus, minimaalsed pimedad kohad',
      productRange: 'Tootevalik',
      vizioPark: 'VizioPark',
      vizioParkDesc: 'Parkimise täituvuse seire',
      vizioYard: 'VizioYard',
      vizioYardDesc: 'Väliste õuede ja logistika seire',
      vizioCount: 'VizioCount',
      vizioCountDesc: 'Punase tule sõidukite loendamine',
      vizioCrowd: 'VizioCrowd',
      vizioCrowdDesc: 'Ülekäiguraja jalakäijate loendamine',
    },
    // Connectivity Section
    connectivity: {
      label: 'Ühenduvus',
      title: 'Mitme võrgu IoT ühenduvus',
      subtitle: 'Valime kõige tõhusama võrgu sõltuvalt teie kasutusjuhtumist. Meie ekspertiis hõlmab mitmeid ühendustehnoloogiaid.',
      lorawan: 'LoRaWAN',
      lorawanDesc: 'Pika ulatusega, madala energiatarbimisega laivõrk IoT jaoks',
      lorawanF1: 'Kuni 15 km ulatus',
      lorawanF2: 'Madal energiatarbimine',
      lorawanF3: 'Kahesuunaline',
      sigfox: 'Sigfox',
      sigfoxDesc: 'Ülimalt kitsas ribalaiustehnoloogia lihtsate IoT sõnumite jaoks',
      sigfoxF1: 'Ülemaailmne katvus',
      sigfoxF2: 'Madalad kulud',
      sigfoxF3: 'Lihtne integratsioon',
      nbiot: 'NB-IoT',
      nbiotDesc: 'Kitsasribaline mobiilitehnoloogia IoT seadmetele',
      nbiotF1: 'Sügav siseruumide katvus',
      nbiotF2: 'Operaatoriklass',
      nbiotF3: 'Turvaline',
      ble: 'BLE',
      bleDesc: 'Bluetooth Low Energy lühimaa ühenduvuseks',
      bleF1: 'Siseruumide positsioneerimine',
      bleF2: 'Varade jälgimine',
      bleF3: 'Madal energia',
      satellite: 'Satelliit',
      satelliteDesc: 'Ülemaailmne ühenduvus, sealhulgas Starlink ühilduvus',
      satelliteF1: 'Kaugemad alad',
      satelliteF2: 'Varuühenduvus',
      satelliteF3: 'Ülemaailmne ulatus',
    },
    // Devices Section
    devices: {
      label: 'Seadmete ökosüsteem',
      title: 'Parima klassi IoT seadmed',
      subtitle: 'Teeme koostööd juhtivate IoT seadmete tootjatega, et pakkuda usaldusväärseid, tööstusliku klassi lahendusi.',
      alsoPartnering: 'Koostöös ka',
      andMore: 'ja teistega.',
      technologyPartners: 'Tehnoloogiapartnerid',
      deviceTypes: 'Seadmetüübid',
      networkTechnologies: 'Võrgutehnoloogiad',
      balticCountries: 'Balti riiki',
    },
    // Customers Section
    customers: {
      label: 'Meid usaldavad',
      title: 'Meie kliendid',
    },
    // Deployments Section
    deployments: {
      label: 'Juurutused',
      title: 'Nad kasutavad 0g Baltics ühenduvust',
      subtitle: 'Meie IoT infrastruktuur toetab tegevusi erinevates tööstusharudes, pakkudes töökindlust ja mõõdetavaid tulemusi.',
      cities: 'Linnad ja omavalitsused',
      citiesDesc: 'Nutika linna taristu linnahalduseks ja avalikeks teenusteks',
      utilities: 'Kommunaalettevõtted',
      utilitiesDesc: 'Kaugmõõtmine ja seire vee, gaasi ja elektri jaoks',
      buildings: 'Ärihooned',
      buildingsDesc: 'Täituvuse seire, õhukvaliteet ja energia optimeerimine',
      logistics: 'Logistikavõrgud',
      logisticsDesc: 'Varade jälgimine ja sõidukipargi haldamine tarneahelates',
      healthcare: 'Tervishoiuasutused',
      healthcareDesc: 'Patsientide seire ja seadmete jälgimine hoolduskeskkondades',
      trustStatement: 'Taristu, millele saate loota.',
      trustStatementSub: 'Ehitatud tööstuslikeks operatsioonideks üle Baltikumi.',
    },
    // Platforms Section
    platforms: {
      label: 'Platvormide paindlikkus',
      title: 'Avatud IoT platvormid',
      subtitle: '0g Baltics toetab oma platvorme, partnerplatvorme ja kolmanda osapoole integratsioonid. Tagame, et te ei ole kunagi lukustatud ühe müüja ökosüsteemi.',
      noLockIn: 'Pole müüja lukustust',
      ownPlatform: '0g Baltics platvorm',
      ownPlatformDesc: 'Meie patenteeritud backend ja frontend platvormid täielikuks IoT halduseks',
      partnerPlatforms: 'Partnerplatvormid',
      partnerPlatformsDesc: 'Sujuv integratsioon partnerite ökosüsteemide ja olemasoleva taristuga',
      thirdParty: 'Kolmanda osapoole integratsioon',
      thirdPartyDesc: 'Avatud API-d ja standardprotokollid mis tahes platvormi integratsiooniks',
    },
    // Consulting Section
    consulting: {
      label: 'Konsultatsioon',
      title: 'Vähendage tegevuskulusid',
      titleHighlight: 'IoT',
      subtitle: 'Meie konsultatsiooniteenused aitavad teil projekteerida, planeerida ja juurutada IoT infrastruktuuri, mis tagab mõõdetava kulude vähendamise ja tegevuse parendamise.',
      service1: 'Taristu projekteerimine',
      service2: 'Seadmete valik',
      service3: 'ROI modelleerimine',
      service4: 'Pilootprojektid',
      service5: 'Juurutusstrateegia',
      roiFocus: 'Keskendume projektidele, mille',
      months: 'kuud',
      roiTarget: 'ROI tasuvusaeg',
      cta: 'Broneeri konsultatsioon',
    },
    // Infrastructure Section
    infrastructure: {
      label: 'Piirkondlik ekspertiis',
      title: 'Ehitame IoT taristut üle Baltikumi',
      subtitle: '0g Baltics töötab linnade, kommunaalettevõtete, tööstusettevõtete ja integraatoritega, et juurutada skaleeritavat IoT taristut Leedus, Lätis ja Eestis.',
      cities: 'Linnad ja omavalitsused',
      utilities: 'Kommunaal ja tööstus',
      integrators: 'Integraatorid ja partnerid',
    },
    // CTA Section
    cta: {
      title: 'Alustage oma IoT projekti',
      subtitle: 'Valmis vähendama tegevuskulusid ja parandama efektiivsust? Broneerige demo, et näha, kuidas IoT taristu saab teie tegevust muuta.',
      button: 'Broneeri demo',
    },
    // Contact Form
    contact: {
      label: 'Võtke meiega ühendust',
      title: 'Arutame teie IoT projekti',
      subtitle: 'Olenemata sellest, kas soovite juurutada nutikat taristut, vähendada tegevuskulusid või uurida IoT lahendusi, oleme siin, et aidata.',
      email: 'E-post',
      whatToExpect: 'Mida oodata',
      expect1: 'Vastus 24 tööpäeva jooksul',
      expect2: 'Esialgne konsultatsioon teie vajaduste mõistmiseks',
      expect3: 'Kohandatud lahenduse ettepanek',
      fullName: 'Täisnimi',
      company: 'Ettevõte',
      phone: 'Telefon',
      country: 'Riik',
      selectCountry: 'Valige riik',
      interest: 'Huvi',
      selectInterest: 'Mis teid huvitab?',
      message: 'Sõnum',
      messagePlaceholder: 'Rääkige meile oma projektist...',
      checkCity: 'Esindan linna või omavalitsust',
      checkIntegrator: 'Olen integraator / paigaldaja',
      checkNewsletter: 'Nõustun uudiskirjade ja värskenduste saamisega',
      checkAgree: 'Nõustun, et minuga võetakse ühendust',
      submit: 'Saada sõnum',
      sending: 'Saatmine...',
      thankYouTitle: 'Täname, et võtsite ühendust 0g Balticsiga',
      thankYouMessage: 'Meie meeskond vaatab teie päringu üle ja võtab teiega peagi ühendust.',
      errorAgree: 'Palun nõustuge kontakteerumisega',
      errorRequired: 'Palun täitke kõik kohustuslikud väljad',
      errorSubmit: 'Vormi esitamine ebaõnnestus. Palun proovige uuesti.',
    },
    // Footer
    footer: {
      description: 'IoT taristu ja nutikad lahendused Baltikumile. Vähendame tegevuskulusid ühendatud seadmete ja nutika taristuga.',
      navigation: 'Navigatsioon',
      legal: 'Juriidiline teave',
      privacyPolicy: 'Privaatsuspoliitika',
      gdpr: 'GDPR',
      terms: 'Teenuse tingimused',
      imprint: 'Juriidiline teade',
      offices: 'Meie kontorid',
      copyright: '© 2026 0g Baltics. Kõik õigused kaitstud.',
    },
    // Languages
    languages: {
      en: 'Inglise',
      lv: 'Läti',
      lt: 'Leedu',
      ee: 'Eesti',
      comingSoon: '',
    },
    // Interest options
    interests: {
      smartLockers: 'Nutikad kapid',
      smartMetering: 'Nutikas mõõtmine',
      assetTracking: 'Varade jälgimine',
      elderlyCare: 'Eakate hoolduse lahendused',
      airQuality: 'Siseõhu kvaliteedi seire',
      energyMonitoring: 'Energiaseire',
      officeManagement: 'Kontoripindade haldamine',
      connectivity: 'Ühenduvuse taristu',
      tektelic: 'Tektelic lüüsid',
      consulting: 'Kulude vähendamise konsultatsioon',
    },
    // Countries
    countries: {
      lithuania: 'Leedu',
      latvia: 'Läti',
      estonia: 'Eesti',
      poland: 'Poola',
      finland: 'Soome',
      sweden: 'Rootsi',
      germany: 'Saksamaa',
      other: 'Muu',
    },
  },
};
